module.exports = __webpack_public_path__ + "static/Cronometro-Black-mobile-fb11b118e4cb6148abc74dcb9d848426.png";